import '../../modules/mode-components';

import * as angular from 'angular';

import SpaceMembershipModalController from './space-membership-modal-controller';
import template from './space-membership-modal.html';

const spaceMembershipDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {
      space: '<',
      owner: '<',
      account: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.spaceMembership', (event) => {
        const modal = Modal.open(
          {
            space: $scope.space,
            owner: $scope.owner,
            account: $scope.account,
          },
          {
            controller: SpaceMembershipModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.spaceMembership'));
    },
  };
};

spaceMembershipDirective.$inject = ['ModalService'];

angular.module('mode.components').directive('editSpaceMembership', spaceMembershipDirective);
